<app-infopost-nav-container [title]="title"
                            [menuItemType]="INFO_POST.MENU_TYPE_INFOPOST">
    <app-infopost-tsp-selector [canViewAll]="true"></app-infopost-tsp-selector>

    <view-body>
        <gms-loading-spinner [loading$]="isLoading$"></gms-loading-spinner>
        <div class="title-bar grid">
            <div class="row">
                <div class="col h3 my-auto">Welcome to {{ (selectedTsp$ | async)?.shortName || 'GasQuest' }}</div>
                <div class="date col my-auto text-right ml-5">It is {{currentDate}}</div>
            </div>
        </div>
        <div class="dashboard grid"
             *ngFor="let tsp of selectedTsps; let i=index">
            <div class="row small-gutters tsp-title">
                <div class="col">
                    {{ tsp.shortName }}
                </div>
            </div>
            <div class="row small-gutters">
                <div class="col">
                    <app-infopost-pipeline-map [selectedTspID]='tsp.providerId'></app-infopost-pipeline-map>
                </div>
                <div class="col">
                    <app-infopost-notice-info-card [selectedTsp]='tsp'></app-infopost-notice-info-card>
                    <app-pipeline-info-card [selectedTsp]='tsp'></app-pipeline-info-card>
                </div>
            </div>
            @if(i !== selectedTsps.length - 1){
            <div class="row small-gutters">
                <div class="col dashboard-footer"></div>
            </div>
            }
        </div>
    </view-body>
</app-infopost-nav-container>